import React from "react";
import { Modal, Spin } from "antd";
import SelectModalContent from "./SelectModalContent";
import { roles } from "../../configs/constants";
const Tooltip = ({ items }) => (
  <div
    style={{
      width: 200,
      backgroundColor: "#fff",
      borderRadius: 6,
      border: "1px solid #ccc",
      padding: 15,
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      zIndex: 1,
      bottom: 40,
      left: -55
    }}
  >
    {items.map(item => {
      return (
        <span key={item.id} style={{ color: "#515151", fonSize: 5 }}>
          {" "}
          - {item.label}
        </span>
      );
    })}
  </div>
);
const Tags = ({
  isTooltipBrandsVisible,
  selectedBrands,
  brandOnMouseEnter,
  brandOnMouseLeave,
  openSelectionModal,
  closeSelectionModal,
  isTooltipProductsVisible,
  selectedProducts,
  productOnMouseEnter,
  productOnMouseLeave,
  isModalOfSelectionVisible,
  categories,
  isModalLoading,
  updateBrandsAndProducts,
  media,
  userRoleId
}) => {
  return (
    <div>
      <div>
        <Modal
          title="Sélection marques et produits"
          visible={isModalOfSelectionVisible}
          onOk={closeSelectionModal}
          onCancel={closeSelectionModal}
        >
          {isModalLoading ? (
            <Spin></Spin>
          ) : (
            <SelectModalContent
              categories={categories}
              selectedBrands={selectedBrands}
              selectedProducts={selectedProducts}
              updateBrandsAndProducts={updateBrandsAndProducts}
              media={media}
            ></SelectModalContent>
          )}
        </Modal>
      </div>
      {userRoleId !== roles.CLIENT &&
        (!Array.isArray(selectedBrands) || selectedBrands.length === 0) &&
        (!Array.isArray(selectedProducts) || selectedProducts.length === 0) && (
          <div
            onClick={openSelectionModal}
            className={userRoleId === roles.CLIENT ? "p-phototheque-item-btn-disable" : "p-phototheque-item-btn"}
          >
            Sélectionner des marques ou produits
          </div>
        )}
      {Array.isArray(selectedBrands) && selectedBrands.length > 0 && (
        <div
          onClick={openSelectionModal}
          onMouseEnter={brandOnMouseEnter}
          onMouseLeave={brandOnMouseLeave}
          className={userRoleId === roles.CLIENT ? "p-phototheque-item-btn-disable" : "p-phototheque-item-btn"}
        >
          Marques
          {isTooltipBrandsVisible && <Tooltip items={Array.isArray(selectedBrands) ? selectedBrands : []}></Tooltip>}
        </div>
      )}
      {Array.isArray(selectedProducts) && selectedProducts.length > 0 && (
        <div
          onClick={openSelectionModal}
          onMouseEnter={productOnMouseEnter}
          onMouseLeave={productOnMouseLeave}
          className={userRoleId === roles.CLIENT ? "p-phototheque-item-btn-disable" : "p-phototheque-item-btn"}
        >
          Produits
          {isTooltipProductsVisible && (
            <Tooltip items={Array.isArray(selectedProducts) ? selectedProducts : []}></Tooltip>
          )}
        </div>
      )}
    </div>
  );
};
export default Tags;



// WEBPACK FOOTER //
// src/components/phototheque/Tags.js